var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/_nativeCreate.js
// module id = 35
// module chunks = 0